/** Normalise a URL for duplicate detection. Never used to rewrite stored URLs. */
export function normalizeUrl(raw: string | null | undefined): string {
  if (!raw) return '';
  const trimmed = raw.trim();
  try {
    const u = new URL(trimmed);
    u.protocol = u.protocol.toLowerCase();
    u.hostname = u.hostname.toLowerCase();
    if ((u.protocol === 'http:' && u.port === '80') || (u.protocol === 'https:' && u.port === '443')) u.port = '';
    let href = u.href;
    if (u.pathname === '/' && !u.search && !u.hash && href.endsWith('/')) href = href.slice(0, -1);
    return href;
  } catch {
    return trimmed;
  }
}

export function hostOf(raw: string | null | undefined): string {
  if (!raw) return '';
  try {
    return new URL(raw).hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
}
